export const obscurePolicyId = (policyId: string) =>
  `********${policyId.slice(8)}`;
